import logger from '@finn-no/fiaas-logger';
import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import querystring from 'querystring';
import { getPageCounter } from 'shared/prometheus/prometheus';
import { SWRConfig } from 'swr';
import { LmsResultPageLayout } from '@/components/lms/LmsResultPageLayout';
import { config, feConfig } from '@/config';
import type { LmsResult } from '@/interfaces/lms';
import { runAllMiddlewares } from '@/server/middleware';

type LmsPageProps = {
    ssrData: LmsResult | null;
    ssrSwrKey: string;
    isLoggedIn?: boolean;
};

const LmsResultPage = ({ ssrData, ssrSwrKey, isLoggedIn }: LmsPageProps) => (
    <SWRConfig value={{ fallback: { [ssrSwrKey]: ssrData } }}>
        <LmsResultPageLayout isLoggedIn={isLoggedIn} />
    </SWRConfig>
);

// biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
export const getServerSideProps = async ({ req, res, query }: GetServerSidePropsContext): Promise<GetServerSidePropsResult<any>> => {
    if (!query.skipSSRData) {
        const props = await runAllMiddlewares(req, res, query);

        const qs = querystring.stringify(query as Record<string, string>);
        const params = qs.length ? `?${qs.toString()}` : '';
        const offerUrl = `${config.get('lms.apiUrlInternal')}/offers${params}`;
        const swrKey = `${config.get('lms.apiUrlExternal')}/offers${params}`;

        const data: LmsResult | null = await fetch(offerUrl)
            .then((response): Promise<LmsResult> => response.json())
            .catch((err) => {
                logger.error(`Could not fetch lms offers data from ${offerUrl}`, err);
                return null;
            });

        getPageCounter().inc({ app: 'pale-pp-web', page: 'lms' });

        return { props: { ...props, config: feConfig, ssrData: data, ssrSwrKey: swrKey, isLoggedIn: !!res.locals?.loginId } };
    }
    return { props: { config: feConfig } };
};

export default LmsResultPage;
